module.exports = __webpack_public_path__ + "img/Hunter-dwarf-f-60.ae8ed52a.gif";